import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import type {
  Discussion,
  LastComment,
} from 'hb-react/frontoffice/components/CardForum/types';
import CommentedLabel from 'hb-react/frontoffice/components/CommentedLabel';
import { itemCommentedLabelParams } from 'hb-react/frontoffice/utils/itemCommentedLabel';

interface DiscussionCommentedLabelProps {
  discussion: Discussion;
}

const DiscussionCommentedLabel = ({
  discussion,
}: DiscussionCommentedLabelProps) => {
  const {
    comments,
    pinned_on_index_page: pinned,
    created_at: createdAt,
  } = discussion;

  if (!comments.last_comment) {
    return null;
  }

  const commentedLabelParams: { comment: LastComment } | null =
    itemCommentedLabelParams({
      item: {
        pinned,
        publishedAt: createdAt,
        comments: [comments.last_comment],
      },
    });

  if (!commentedLabelParams) {
    return null;
  }

  const { user, created_at: createdAtComment } = commentedLabelParams.comment;

  return (
    <Box display="block" data-testid="commented-label" mb={4}>
      <CommentedLabel
        comment={{
          user,
          created_at: createdAtComment,
        }}
      />
      <Divider mt={4} mb={2} />
    </Box>
  );
};

export default DiscussionCommentedLabel;
